import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import InvoiceGochiTableHead from '../../components/molecules/InvoiceGochiTableHead';
import InvoiceGochiTableBody from '../../components/molecules/InvoiceGochiTableBody';
import ExPagination from '../../components/molecules/ExPagination';
import { sendLogin } from '../../auth/Auth';
import ProgressDialog from '../../components/molecules/ProgressDialog';

const styles = {
  scrollTable: {
    maxHeight: '60vh',
    overflowX: 'scroll',
    whiteSpace: 'nowrap',
    display: 'block',
    width: '100%'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(state => ({
    listInvoiceGochi: state.shops.listInvoiceGochi,
    totalCount: state.shops.listInvoiceGochi.totalCount,
    count: state.shops.listInvoiceGochi.count,
    offset: state.shops.listInvoiceGochi.offset,
    limit: state.shops.listInvoiceGochi.limit
  })),
  setPropTypes(propTypes),
  withState('loading', 'updateLoading', false),
  withState('openFullMessage', 'updateOpenFullMessage', false),
  withState('fullMessage', 'setFullMessage', ''),
  withState('rowsPerPage', 'setRowsPerPage', 100),
  withState('targetRowId', 'setTargetRowId', 0),
  withState('order', 'setOrder', 'asc'),
  withState('orderBy', 'setOrderBy', null),
  withState('openDelete', 'updateOpenDelete', false),
  withState('openProgress', 'updateOpenProgress', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('deleteMessage', 'setDeleteMessage', ''),
  // withState('page', 'setPage', 0),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleChangeRowsPerPage: props => event => {
      props.setRowsPerPage(event.target.value);
    },
    handleRequestSort: props => property => {
      const isDesc = props.orderBy === property && props.order === 'desc';
      props.setOrder(isDesc ? 'asc' : 'desc');
      props.setOrderBy(property);
    }
  }),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    classes,
    page,
    selectedPage,
    handleChangePage,
    listInvoiceGochi,
    count,
    offset,
    rowsPerPage,
    setTargetRowId,
    order,
    orderBy,
    handleChangeRowsPerPage,
    handleRequestSort,
    loading,
    updateOpenProgress,
    openProgress,
    resultMessage,
    limit
  }) => {
    const progressOkAction = () => {
      updateOpenProgress(false);
    };

    let totalGochi = 0;
    if (totalGochi.list && totalGochi.list.length) {
      totalGochi = totalGochi.list.length;
    }

    const emptyRows =
      rowsPerPage - Math.min(rowsPerPage, totalGochi - page * rowsPerPage);

    return (
      <div>
        <div className={classes.scrollTable} id="scrollTableId">
          <Table stickyHeader>
            <InvoiceGochiTableHead
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
            />
            <InvoiceGochiTableBody
              gochis={listInvoiceGochi.list}
              emptyRows={emptyRows}
              page={page}
              limit={limit}
              rowsPerPage={rowsPerPage}
              order={order}
              orderBy={orderBy}
              setTargetRowId={setTargetRowId}
            />
          </Table>
        </div>
        <div>
          <ExPagination
            searchResults={listInvoiceGochi.list}
            rowsPerPage={rowsPerPage}
            page={page}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            totalCount={count}
            offset={offset}
            selectedPage={selectedPage}
          />
        </div>
        <ProgressDialog
          openProgress={openProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
